import Login from '../containers/Login';
import BlankPage from '../containers/BlankPage';
import Reportediario from '../containers/Reportediario';
import Afiliacion from '../containers/Afiliacion';
import MetodosPago from '../containers/MetodosPago';
import ListarUsuarios from '../containers/ListarUsuarios';
import GestionAtributos from '../containers/GestionAtributos';
import MfaLogin from '../containers/MfaLogin';
import CrearUsuario from '../containers/CrearUsuario';
import ActualizarUsuario from '../containers/ActualizarUsuario';
import ActualizarContrasena from '../containers/ActualizarContrasena';


var appRoutes = [
    { path: "/login", name: "Login", component: Login, access: "public" },
    { path: "/verifycode", name: "MFA", component: MfaLogin, access: "public" },
    { path: "/blankpage", name: "BlankPage", component: BlankPage, access: "public"},
    { path: "/reportediario", name: "Reportediario", component: Reportediario, access: "private"},
    { path: "/afiliacion", name: "Afiliacion", component: Afiliacion, access: "private"},
    { path: "/metodospago", name: "MetodosPago", component: MetodosPago, access: "private"},
    { path: "/lstusuarios", name: "ListarUsuarios", component: ListarUsuarios, access: "private"},
    { path: "/gestatributo", name: "GestionAtributos", component: GestionAtributos, access: "private"},
    { path: "/validation", name: "MFA", component: MfaLogin, access: "public"}    
];

export default appRoutes;